import React, { Component } from 'react';
import { firebaseDb } from 'src/firebase';

import FormErrors from '../form-errors/form-errors.js'

const icon = <svg className="svgIcon fill-smoke--d fill-blue--active" width="30" height="30" viewBox="0 -6 30 30">
<path d="M15 11.9c-.9 0-1.7-.2-2.3-.7l-5.7-4.4v8.1c0 .1 0 .3.1.4.1.1.2.2.3.2 2.5.4 5 .5 7.5.5s5-.2 7.5-.5c.1 0 .3-.1.4-.2.2-.1.2-.3.2-.4v-8.1l-5.7 4.4c-.6.5-1.4.7-2.3.7zm-1.3-2.3c.3.3.8.4 1.3.4s1-.1 1.3-.4l6.1-4.7c.3-.3.5-.6.6-1v-.8c0-.1 0-.3-.1-.4-.1-.1-.2-.2-.4-.2-2.5-.3-5-.5-7.5-.5s-5 .2-7.5.5c-.1 0-.2.1-.3.2-.2.1-.2.3-.2.4v.9c.1.3.3.6.6 1l6.1 4.6z"></path>
</svg>;

class SignUpForm extends Component {
  constructor() {
    super();

    this.state = {
      isNavOpen: false,
      hasScrolled: false,
      filtered:false,
      activeFilter:0,
      fade:false,
      email:'',
      formErrors: {email: ''},
      formValid:'true',
      formSubmitted:false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e){
    const name = e.target.name;
    const val = e.target.value


    this.setState({[name]:  val},
                () => { this.validateField(name,  val) });
  }

  validateField(fieldName, value) {
  let fieldValidationErrors = this.state.formErrors;
  let emailValid = this.state.emailValid;
  let passwordValid = this.state.passwordValid;

  switch(fieldName) {
    case 'email':
      emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      fieldValidationErrors.email = emailValid ? '' : ' is invalid';
      break;
    case 'password':
      passwordValid = value.length >= 6;
      fieldValidationErrors.password = passwordValid ? '': ' is too short';
      break;
    default:
      break;
  }
  this.setState({formErrors: fieldValidationErrors,
                  emailValid: emailValid,
                  passwordValid: passwordValid
                }, this.validateForm);
}

validateForm() {
  if(this.state.formErrors.email!==''){
    this.setState({formValid: false});
  }
  else{
    this.setState({formValid:true})
  }
}


  handleSubmit(e) {
    e.preventDefault();
    if(this.state.formSubmitted===true){
      return false;
    }
    const email = this.state.email
    var key = email.replace(/\./g,'');

    const itemsRef = firebaseDb.ref('emails/'+key);

    var that = this;
    // itemsRef.set({[key]: email}, function(error) {
      itemsRef.set({email}, function(error) {
      if (error) {
       // alert("Data could not be saved." + error);
      } else {
        //data has been saved
        that.setState({
          formSubmitted:true
        })
      }
    });

    this.setState({
      currentItem: '',
      username: ''
    });
}

  render () {
    var btn = this.props.buttonColor
    var btnHover = this.props.buttonHover
    return(
      <div style={{position:'relative', height:'auto', borderRadius:'10px', padding:'4px', background:'#fff'}}>

      <iframe src="https://upscri.be/a6c852-2?as_embed" height="360" frameborder="0" style={{width:'100%',maxWidth:'800px',margin:'0 auto', border:'0px', borderRadius:'10px'}}></iframe>
            {/* <form onSubmit={this.handleSubmit}>
                <input type='text' name="email" onChange={this.handleChange} placeholder="Pop your email address in here" />
                <button
                style={{position:'absolute', top:this.props.positionTop, right:this.props.positionRight, height:'46px', borderTopLeftRadius:'0', borderBottomLeftRadius:'0'}}
                className="button button__accent"
                  onClick={this.handleSubmit}
                  isDisabled={!this.state.formValid}
                  hasSucceeded={this.state.formSubmitted}
                  hover = {this.state.formSubmitted ? btn : btnHover}
                  background={this.state.formSubmitted ? btn : btnHover}
                  size="large">{this.props.message}
                </button>
          <FormErrors formErrors={this.state.formErrors} />

        </form> */}

    </div>
    );

  }
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/views/components/signup-form/signup-form.js